import { defineStore } from 'pinia';

interface ISystemAlertError {
    message: string
    type: 'success' | 'info' | 'warning' | 'error',
}
interface ISystemAlertState {
    errors: ISystemAlertError[]
}

export const useSystemAlertStore = defineStore({
    id: 'systemAlertStore',
    state: (): ISystemAlertState => ({
        errors:[],
    }),

    actions: {
        addError( o: ISystemAlertError) { this.errors.push(o) },
        addSuccess( o: ISystemAlertError) { this.errors.push(o) }
    }
})
